import type { Dispatch, SetStateAction } from 'react';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import BenefitDocuments from '../benefit-documents/benefit-documents';
import { SectionContainer } from './styles';
import type { DocumentsForm } from './types';

interface BenefitDocumentsElementProps {
  form: DocumentsForm;
  isCloneBenefit: boolean;
  setIsUploadInProgress: Dispatch<SetStateAction<boolean>>;
}

const BenefitDocumentsElement = ({
  form,
  isCloneBenefit,
  setIsUploadInProgress,
}: BenefitDocumentsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <BenefitDocuments
        isCloneBenefit={isCloneBenefit}
        setIsUploadInprogress={setIsUploadInProgress}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(BenefitDocumentsElement);
